import React, { useRef, useEffect, useState } from 'react';

const HTMLContentIframe = ({ content }) => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState('auto');

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === 'setHeight') {
        setIframeHeight(`${event.data.height}px`);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const srcdocContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
            font-size: 14px;
            line-height: 1.6;
            color: #252526;
            padding: 0;
            margin: 0;
            background: transparent;
          }
          
          p {
            margin: 0 0 16px 0;
            line-height: 1.6;
          }
          
          p:last-child {
            margin-bottom: 0;
          }
          
          strong, b {
            font-weight: 700;
            color: #000000;
          }
          
          a {
            color: #1B67DA;
            text-decoration: underline;
            cursor: pointer;
          }
          
          a:hover {
            color: #1557B0;
          }
          
          h1 {
            font-size: 28px;
            font-weight: 700;
            margin: 0 0 20px 0;
            line-height: 1.2;
            color: #000000;
          }
          
          h1:not(:first-child) {
            margin-top: 32px;
          }
          
          h2 {
            font-size: 24px;
            font-weight: 700;
            margin: 0 0 16px 0;
            line-height: 1.3;
            color: #000000;
          }
          
          h2:not(:first-child) {
            margin-top: 28px;
          }
          
          h3 {
            font-size: 20px;
            font-weight: 700;
            margin: 0 0 12px 0;
            line-height: 1.3;
            color: #000000;
          }
          
          h3:not(:first-child) {
            margin-top: 24px;
          }
          
          h4 {
            font-size: 18px;
            font-weight: 700;
            margin: 0 0 10px 0;
            line-height: 1.3;
            color: #000000;
          }
          
          h4:not(:first-child) {
            margin-top: 20px;
          }
          
          ul, ol {
            margin: 8px 0 16px 0;
            padding-left: 24px;
          }
          
          li {
            margin-bottom: 6px;
            line-height: 1.6;
          }
          
          ul {
            list-style-type: disc;
          }
          
          ol {
            list-style-type: decimal;
          }
          
          img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 12px 0;
          }
          
          blockquote {
            border-left: 4px solid #D8D8D9;
            padding-left: 16px;
            margin: 16px 0;
            font-style: italic;
            color: #555;
          }
          
          code {
            background-color: #F5F5F5;
            padding: 2px 6px;
            border-radius: 3px;
            font-size: 13px;
            font-family: 'Monaco', 'Courier New', monospace;
          }
          
          pre {
            background-color: #F5F5F5;
            padding: 12px;
            border-radius: 4px;
            overflow-x: auto;
            margin: 12px 0;
          }
          
          pre code {
            background: none;
            padding: 0;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 12px 0;
          }
          
          th, td {
            border: 1px solid #D8D8D9;
            padding: 8px;
            text-align: left;
          }
          
          th {
            background-color: #F5F5F5;
            font-weight: 600;
          }
          
          hr {
            border: none;
            border-top: 1px solid #D8D8D9;
            margin: 16px 0;
          }
        </style>
      </head>
      <body>
        ${content}
        <script>
          function sendHeight() {
            const height = document.body.scrollHeight;
            window.parent.postMessage({ type: 'setHeight', height: height }, '*');
          }
          
          window.addEventListener('load', sendHeight);
          
          const observer = new MutationObserver(sendHeight);
          observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true
          });
          
          sendHeight();
        </script>
      </body>
    </html>
  `;

  return (
    <iframe
      ref={iframeRef}
      srcDoc={srcdocContent}
      className="w-full border-0 max-h-[247px] overflow-y-auto"
      style={{ height: iframeHeight }}
      title="HTML Content"
      sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    />
  );
};

export default HTMLContentIframe;
